import Constants from '@/Constants';
import Loader from '@/components/Loader';
import { OrganizationStatsRequest } from '@/models/OrganizationStatsRequests';
import { courseService } from '@/services/CourseService';
import { getDisplayName } from '@/services/UtilService';
import { ApplicationState } from '@/store';
import { getOrganizationStatsRequest } from '@/store/appOrganization/action';
import { getCategoriesRequest } from '@/store/category/action';
import { getItensRequest } from '@/store/item/action';
import { getListsRequest } from '@/store/list/action';
import { getUsersRequest } from '@/store/user/action';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import CardAction from './componentes/CardAction';
import Greeting from './componentes/Greeting';
import './style.scss';

const Home: React.FC = () => {
    const history = useHistory();
    const dispatch = useDispatch();
    const [lmsCardData, setLmsCardData] = useState<any>([]);
    const [playlistsCardData, setPlaylistsCardData] = useState<any>([]);
    const [licencesCardData, setLicencesCardData] = useState<any>([]);

    const { identity, strings, totalLicenses, person, totalUsers, loadingUsers, loadingItens, loadingLists, stats, modules } = useSelector(
        (state: ApplicationState) => {
            return {
                identity: state.identity.data,
                strings: state.locale.data,
                totalLicenses: state.appOrganization.data.totalLicenses,
                person: state.identity.data.person,
                totalUsers: state.users.data.total,
                loadingUsers: state.users.loading,
                loadingItens: state.itens.loading,
                loadingLists: state.lists.loading,
                stats: state.appOrganization.data.stats,
                modules: state.appOrganization.data.modules,
            };
        },
    );

    useEffect(() => {
        const {
            user: { orgId, applicationId },
        } = identity;
        dispatch(
            getOrganizationStatsRequest({
                organizationId: orgId,
                applicationId,
                moduleIds: courseService.getModuleIdsForRequest(modules, [Constants.PLAYLIST_MODULE_ID, Constants.LMS_MODULE_ID]),
            } as OrganizationStatsRequest),
        );
        dispatch(getCategoriesRequest({ orgId, applicationId }));
        dispatch(getUsersRequest({ orgId, applicationId, onlyActive: true, offset: 0, limit: 0 }));
        dispatch(getItensRequest({ orgId, applicationId, name: '', offset: 0, limit: 0 }));
        dispatch(
            getListsRequest({
                orgId,
                applicationId,
                name: '',
                offset: 0,
                limit: 0,
                onlyHasProgramClass: 0,
                moduleId: Constants.PLAYLIST_MODULE_ID,
            }),
        );
    }, [dispatch, strings._LANGUAGE]);

    useEffect(() => {
        if (stats) {
            const currentLmsData = [
                {
                    title: strings.COURSES,
                    subItems: [
                        {
                            value: stats.coursesAmount,
                            iconType: 'material-icons-outlined',
                            iconName: Constants.icons.SCHOOL,
                        },
                        {
                            value: formartWorkload(stats.coursesWorkload),
                            iconType: 'material-icons',
                            iconName: Constants.icons.ALARM,
                        },
                    ],
                },
                {
                    title: strings.PROGRAMS,
                    subItems: [
                        {
                            value: stats.programsAmount,
                            iconType: 'material-icons',
                            iconName: Constants.icons.LIST_ALT,
                        },
                        {
                            value: formartWorkload(stats.programsWorkload),
                            iconType: 'material-icons',
                            iconName: Constants.icons.ALARM,
                        },
                    ],
                },
            ];

            const currentPlaylistData = [
                {
                    title: strings.ITEMS,
                    subItems: [
                        {
                            value: stats.contentsAmount,
                            iconType: 'material-icons-outlined',
                            iconName: Constants.icons.FILE_DOCUMENT_OUTLINE,
                        },
                        {
                            value: formartWorkload(stats.contentsWorkload),
                            iconType: 'material-icons',
                            iconName: Constants.icons.ALARM,
                        },
                    ],
                },
                {
                    title: strings.LISTS,
                    subItems: [
                        {
                            value: stats.playlistsAmount,
                            iconType: 'material-icons-outlined',
                            iconName: Constants.icons.BALLOT,
                        },
                        {
                            value: formartWorkload(stats.playlistsWorkload),
                            iconType: 'material-icons',
                            iconName: Constants.icons.ALARM,
                        },
                    ],
                },
            ];

            const currentLicencesData = [
                {
                    title: strings.REGISTERED,
                    subItems: [
                        {
                            value: totalUsers ? totalUsers : 0,
                            conditionalValue: totalLicenses ? totalLicenses : null,
                            iconType: 'material-icons',
                            iconName: Constants.icons.PERSON,
                        },
                    ],
                },
                {
                    title: strings.AVAILABLE,
                    subItems: [
                        {
                            value: totalLicenses ? totalLicenses - (totalUsers || 0) : strings.UNLIMITED,
                            conditionalValue: totalLicenses ? totalLicenses : 0,
                            iconType: 'material-icons',
                            iconName: Constants.icons.PERM_IDENTITY,
                        },
                    ],
                },
            ];

            setLmsCardData(currentLmsData);
            setPlaylistsCardData(currentPlaylistData);
            setLicencesCardData(currentLicencesData);
        }
    }, [stats, totalUsers, totalLicenses]);

    const formartWorkload = (workload: number): string => {
        const hours = Math.floor(workload / 60);
        const minutes = Math.floor(workload % 60);
        return hours > 0 && minutes > 0 ? `${hours}h+` : hours > 0 && minutes == 0 ? `${hours}h` : hours == 0 && minutes > 0 ? `${minutes}min` : '0h';
    };

    const handleItems = (): void => {
        history.push('/contents/lms/courses');
    };

    const handleLists = (): void => {
        history.push('/contents/playlist/items');
    };

    const handlePeople = (): void => {
        history.push('/people');
    };

    return (
        <main className="home">
            {loadingUsers || loadingLists || loadingItens ? (
                <Loader />
            ) : (
                <>
                    <Greeting name={getDisplayName(person)} />
                    <div className="d-flex flex-row justify-content-center">
                        <CardAction actionLabel={strings.CREATE} handleAction={handleItems} items={lmsCardData} title={strings.LMS} />
                        <CardAction actionLabel={strings.CREATE} handleAction={handleLists} items={playlistsCardData} title={strings.PLAYLIST} />
                        <CardAction actionLabel={strings.MANAGE} handleAction={handlePeople} items={licencesCardData} title={strings.LICENCES} />
                    </div>
                </>
            )}
        </main>
    );
};

export default Home;
